import type { Certification } from '@axiom/validation';

export const QualificationsCertificationsAccomplishmentsUtil = {
  getInstitutionYearText: ({ institution, year }: Certification) => {
    return institution && year
      ? `${institution}, ${year}`
      : institution || year || null;
  },
};
